<template>
	<ol class="breadcrumb">
		<li class="breadcrumb-item" :key="index" v-for="(item, index) in items">
			<span class="active" v-if="!items[1 + index]">{{ $t(showName(item)) }}</span>
			<router-link :to="item" v-else>{{ $t(showName(item)) }}</router-link>
		</li>
	</ol>
</template>
<script>
export default {
	props: {
		list: {
			type: Array,
			required: true,
			default: () => [],
		},
	},
	data() {
		return {
			items: [],
		}
	},
	methods: {
		isLast(index) {
			return index === this.list.length - 1
		},
		showName(item) {
			if (item && item.hasOwnProperty('name') && item.name) {
				if (item.meta && item.meta.label) {
					item = item.meta && item.meta.label
				}
				if (item.hasOwnProperty('name')) {
					item = item.name
				}

				if (
					(this.$route.params.id && Number(this.$route.params.id) > 0) ||
					(this.$route.params.variable_id && Number(this.$route.params.variable_id) > 0)
				) {
					item = item.replace('%1', 'Edit ')
				} else {
					item = item.replace('%1', 'New ')
				}
				// item = item.replace('%1', (this.$route.params.id && Number(this.$route.params.id) > 0 ? "Edit" : "New") + " ");
				item = item.replace(
					'%2',
					(this.$route.params.command_id && Number(this.$route.params.command_id) > 0 ? 'Edit' : 'New') + ' '
				)
				return item
			}
		},
		clean_empty_links(list) {
			if (!list.length) return []
			var f = list.splice(0, 1)[0]
			return [].concat(!!f.name ? f : [], this.clean_empty_links(list))
		},
	},
	mounted() {
		this.items = this.clean_empty_links(this.list.slice())
	},
}
</script>
